import {Heading, Img} from "components"
import React from "react";

interface Props {
    number?: number,
    NumberColor?: string,
    className?: string,
    icon?: string;
    text?: string;
    title?: string;
    price?: string;
    description?: string;
    bg?: string;
}

export default function MainProjectsTabs({...props}) {
    return (
        <div
            {...props}
            className={`${props.className} ${props.bg} flex flex-col lg:gap-[100px] gap-[48px] lg:p-10 p-6 rounded-[48px] md:rounded-[32px] sm:rounded-[32px]`}>
            <Heading
                size={"desktop_numeric_xl_bold"}
                className={`${props.NumberColor}`}>
                {props.number}
            </Heading>
            <div className=" flex flex-row items-start self-stretch  sm:flex-col sm:mb-6 sm:px-6 gap-5">
                <Heading
                    size="desktop_heading_5"
                    className={`${props.text} md:hidden sm:hidden font-semibold leading-[120%] uppercase w-[305px] h-[112px] whitespace-pre-line`}>
                    {props.title}
                </Heading>
                <Heading
                    size="desktop_body_l"
                    className={`${props.text} md:hidden sm:hidden font-medium w-[305px] whitespace-pre-line`}>
                    {props.description}
                </Heading>
                {/*--------------*/}
                <Heading
                    className={`${props.text} lg:hidden sm:hidden font-medium text-[20px] leading-[120%] uppercase w-[305px] whitespace-pre-line`}>
                    {props.title}
                </Heading>
                <Heading
                    size={"desktop_body_m"}
                    className={`${props.text} lg:hidden sm:hidden font-medium w-[50%]`}>
                    {props.description}
                </Heading>
                {/*--------------*/}
                <Heading
                    size="desktop_heading_6"
                    className={`${props.text} lg:hidden md:hidden font-medium leading-[120%] uppercase w-[305px] h-auto`}>
                    {props.title}
                </Heading>
                <Heading
                    size="desktop_body_m"
                    className={`${props.text} lg:hidden md:hidden font-medium whitespace-pre-line mt-4`}>
                    {props.description}
                </Heading>
            </div>
        </div>
    )
}